import React from "react";

const FormInputTextAreaComponent = ({
  label,
  id,
  name,
  placeholder,
  value,
  error,
  onChange,
  isVertical = false,
  isRequired = false,
  isDisabled = false,
}) => {
  const handleChange = (e) => {
    if (onChange) onChange(e.target.value);
  };
  return (
    <div className="col-12">
      <div className={isVertical ? "" : "mb-1 row"}>
        {label && (
          <div className={isVertical ? "col-sm-12" : "col-sm-2"}>
            <label className="col-form-label">
              {label}
              {isRequired && <> * </>}
            </label>
          </div>
        )}
        <div className={isVertical ? "col-sm-12" : "col-sm-10"}>
          <textarea
            style={{ height: 150 }}
            className={`form-control ${error ? "is-invalid" : ""}`}
            placeholder={placeholder}
            id={id}
            name={name}
            onChange={handleChange}
            disabled={isDisabled}
          >
            {value}
          </textarea>
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default FormInputTextAreaComponent;
